import { EnableDocumentsRecognitionApiCall } from 'reactApp/api/DocumentApiCall';
import { changeHomeHistory } from 'reactApp/modules/home/home.actions';
import { createFamilyFolderRequest } from 'reactApp/modules/modifying/sagas/createFolder.saga';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { store } from 'reactApp/store';

const enableDocumentsRecognitionApiCall = () => new EnableDocumentsRecognitionApiCall().makeRequest();

export function* enableDocumentsSaga() {
    try {
        yield enableDocumentsRecognitionApiCall();
        const { folderName } = yield createFamilyFolderRequest({
            conflictMode: undefined,
            createdInToolbar: false,
            folderName: 'Документы семьи',
            gaPrefix: '',
            parent: '/',
            publishPromoTooltip: undefined,
            share: false,
            skipXhr: undefined,
            storage: 'home',
        });
        if (folderName) {
            store.dispatch(changeHomeHistory({ id: folderName }));
        }
    } catch (error) {
        store.dispatch(
            showSnackbarAction({
                id: 'family-documents-error',
                type: SnackbarTypes.failure,
                text: 'Что‑то пошло не так — попробуйте ещё раз чуть позже',
                closable: true,
            })
        );
    }
}
